function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.881 10.6325L23.0035 6.57124V28.4288L14.881 24.3675V10.6325ZM12.371 7.34689L27.0648 0V35L12.371 27.6531H4.72788C2.48491 27.6531 0.666626 25.8349 0.666626 23.5919V11.4081C0.666626 9.16517 2.48491 7.34689 4.72788 7.34689H12.371ZM10.8197 11.4081H4.72787V23.5919H10.8197V11.4081ZM29.6902 12.844L32.5619 9.97227L37.2179 14.6283L41.8739 9.97227L44.7456 12.844L40.0896 17.5L44.7456 22.156L41.8739 25.0278L37.2179 20.3717L32.5619 25.0278L29.6902 22.156L34.3462 17.5L29.6902 12.844Z",
  fill: "white"
});

var SvgSoundOff = function SvgSoundOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound_off.f4f7f71e.svg";
export { ForwardRef as ReactComponent };